import Consts from '@/common/consts'

const Cookie = {}
/**
 * 存cookie
 * @param key
 * @param value
 * @param expireHour 小时
 */
Cookie.set = function(key, value, expireHour) {
  let expires = new Date()
  expires.setTime(expires.getTime() + (expireHour || 365 * 24) * 60 * 60 * 1000)
  let _domain = ''
  if (window.location.host.match(/.*\.dshui\.com/g) || window.location.host.match(/.*\.dsh315\.com/g)) {
    _domain = Consts.WAP_HOST
  }
  let cookieArr = []
  cookieArr.push(`${key}=${encodeURIComponent(value)};`)
  cookieArr.push(`expires=${expires.toGMTString()};`)
  cookieArr.push(`domain=${_domain};`)
  cookieArr.push('path=/;')
  document.cookie = cookieArr.join('')
}
/**
 * 取cookie
 */
Cookie.get = function(key) {
  let cookies = document.cookie ? document.cookie.split('; ') : []
  for (let i = 0; i < cookies.length; i++) {
    let parts = cookies[i].split('=')
    if (key && parts.length > 1 && key === parts[0]) {
      return decodeURIComponent(parts[1])
    }
  }
  return ''
}
/**
 * 清除cookie
 */
Cookie.del = function(key) {
  Cookie.set(key, '', -1)
}
export default Cookie
